import Home from "@/components/common/home/mobile";

export default function HomeView() {
  return <Home />;
}
